import { type } from "os";

export interface Rule {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const RuleSchema = {
  name: 'Rule',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    description: { type: 'string' },
    rule_type: { type: 'string' },
    rule_no: { type: 'string' },
    section_no: { type: 'string' },
    unique_identifier: { type: 'string' },
  }
};
